import { Component, Watch, Vue } from 'vue-property-decorator';

import { Getter } from 'vuex-class';

// Components
import QuestionBox from './QuestionBox.vue';
import EmailTheResults from '../followup/EmailTheResults.vue';
import QuestionsFinishedModal from './QuestionsFinishedModal.vue';
import { Option } from '@/models/option';
import { Topic } from '@/models/topic';

@Component({
    components: {
        // Include components
        QuestionBox,
        EmailTheResults,
        QuestionsFinishedModal,
    },
})

export class QuestionBase extends Vue {
    protected isModalActive: boolean = false;

    @Getter('topic/topics') protected topics: Topic[];
    @Getter('wizard/laterGoToPhotos') protected laterGoToPhotos: boolean;
    @Getter('configuration/selectedOptions') private selectedOptions: Option[];

    protected toggleModal() {
        this.isModalActive = !this.isModalActive;
    }

    protected goToPhotos() {
        // Check again if all questions are answered
        if (this.selectedOptions.length === this.topics.length) {
            this.$store.commit('wizard/setCurrentTab', 2);
        }
    }

    @Watch('selectedOptions')
    private selectedOptionsChanged() {
        this.isModalActive = this.allQuestionsAnswered();
    }

    private reset() {
        // Reset the configuration
        this.$store.commit('configuration/reset');

        // Set the active topic to be the first one
        this.$store.commit('topic/setActiveTopic', this.topics[0]);

        // Reset the go later to photos
        this.$store.commit('wizard/setLaterGoToPhotos', false);
        this.$store.commit('wizard/setLaterGoToResults', false);
    }

    private allQuestionsAnswered() {
        return (this.selectedOptions.length === this.topics.length && !this.laterGoToPhotos);
    }
}
